import { MapPoint } from "common/types/MapArea";
import { NameID } from "common/types/NameID";

export const useAreas = () => {
  const toAreaString = (areas?: NameID[]) => {
    if (areas === undefined || areas.length === 0) return "";
    return areas.map((area) => area.name).join("\n");
  };

  const toPointString = (point: MapPoint) => {
    const pointLabel = point.title?.trim() || "位置";
    return `${pointLabel}\n(${point.area?.name ?? "その他"})`;
  };

  return { toAreaString, toPointString };
};
